import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.svg";

const FlowHeader = () => {
  return (
    <header className="w-full bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex flex-col items-center">
          <div className="w-32">
            <img src={Logo} alt="Yıkafoni Logo" className="w-full h-auto" />
          </div>
          <span className="font-sans text-[11.43px] leading-[26.67px] text-[#4F46E5] font-bold">
            TEMİZLİK BURADA
          </span>
        </Link>

        {/* Vazgeçtim butonu */}
        <button className="text-gray-600 hover:text-gray-800">
          Vazgeçtim, geri dön.
        </button>
      </div>
    </header>
  );
};

export default FlowHeader;
